import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import analyticMiddleware from '../middleware/analyticMiddleware'
import notificationReducer from '../reducers/notificationReducer'
import sharedReducer from '../reducers/sharedReducer'
import formReducer from '../reducers/formReducer'
import headerReducer from '../reducers/headerReducer'
import { errorReducer } from '../reducers/errorReducer'
import loginReducer from '../reducers/loginReducer'
import cartReducer from '../reducers/cartReducer'

const storeHeader = configureStore({
  reducer: {
    forms: formReducer,
    notification: notificationReducer,
    shared: sharedReducer,
    cart: cartReducer,
    header: headerReducer,
    errors: errorReducer,
    login: loginReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk, analyticMiddleware),
  devTools: import.meta.NODE_ENV !== 'production',
})

export default storeHeader
